define([
    '../slide'
], function (SlideComponent) {
    'use strict';

    /**
     * @class DelayedSlideComponent
     * @extends {SlideComponent}
     * @inheritDoc
     */
    return SlideComponent.extend({
        /**
         * @param {Element} slideElement element to scrolltrigger
         * @returns {ScrollTrigger.Vars} element's scrolltrigger config
         */
        getScrollTriggerConfig: function (slideElement) {
            const tl = this.gsap.timeline();
            tl.from(slideElement, {
                y: (i, target) => innerHeight / 3,
                duration: 0.3
            });

            return Object.assign({}, this._super(), {
                trigger: slideElement,
                scrub: 1,
                start: () => 'top bottom',
                end: () => `top center-=${innerHeight / 3}`,
                animation: tl
            });
        }
    });
});
